type IdiomaComponente = "pt" | "en" | "es" | "zh-CN";

const rows: ReadonlyArray<readonly [string, string, string, string, string]> = [
  ["Aumentar valor", "Aumentar valor", "Increase value", "Aumentar valor", "增加数值"],
  ["Diminuir valor", "Diminuir valor", "Decrease value", "Disminuir valor", "减小数值"],
];

export const TEXTOS_COMPONENTES_UI: Record<IdiomaComponente, Record<string, string>> = {
  pt: Object.fromEntries(rows.map(([key, pt]) => [key, pt])),
  en: Object.fromEntries(rows.map(([key, , en]) => [key, en])),
  es: Object.fromEntries(rows.map(([key, , , es]) => [key, es])),
  "zh-CN": Object.fromEntries(rows.map(([key, , , , zh]) => [key, zh])),
};
